import { linkpickTheme, switchThemeComponent } from '@webapps/styles';

const { params: linkpickParams } = linkpickTheme;

const {
  colors: { black1, white },
  images: {
    OpcoAfdas,
    OpcoAtlas,
    OpcoOcapiat,
    OpcoUniformation,
    OpcoConstructys,
    Opcommerce,
    OpcoAkto,
    Opco2i,
    OpcoMobilites,
    OpcoEp,
    OpcoSante,
    Actions,
    Billings,
    Degree,
    Records,
    Trainings,
  }
} = linkpickParams;

const defaultTheme = {
  colors: {
    testColor: black1,
    background: white,
  },
  images: {
    OpcoAfdas,
    OpcoAtlas,
    OpcoOcapiat,
    OpcoUniformation,
    OpcoConstructys,
    Opcommerce,
    OpcoAkto,
    Opco2i,
    OpcoMobilites,
    OpcoEp,
    OpcoSante,
    Actions,
    Billings,
    Degree,
    Records,
    Trainings,
  }
};

export default switchThemeComponent({
  default: defaultTheme,
});
